import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat, StickyMobileCTA } from "@/components/layout/Floating";
import { Analytics } from "@/components/layout/Analytics";
import Home from "@/pages/Home";

const Programs = lazy(() => import("@/pages/Programs")), CourseDetail = lazy(() => import("@/pages/CourseDetail")), Compare = lazy(() => import("@/pages/Compare")),
  LearningPaths = lazy(() => import("@/pages/LearningPaths")), MarketLab = lazy(() => import("@/pages/MarketLab")), Mentors = lazy(() => import("@/pages/Mentors")),
  Nism = lazy(() => import("@/pages/Nism")), Events = lazy(() => import("@/pages/Events")), StudentStories = lazy(() => import("@/pages/StudentStories")),
  Resources = lazy(() => import("@/pages/Resources")), Blog = lazy(() => import("@/pages/Blog")), Article = lazy(() => import("@/pages/Article")),
  About = lazy(() => import("@/pages/About")), Contact = lazy(() => import("@/pages/Contact")), Faq = lazy(() => import("@/pages/Faq")), Legal = lazy(() => import("@/pages/Legal")),
  SeoLanding = lazy(() => import("@/pages/SeoLanding")), Community = lazy(() => import("@/pages/Community")), BookCounselling = lazy(() => import("@/pages/BookCounselling")),
  NotFound = lazy(() => import("@/pages/NotFound")), AdminLogin = lazy(() => import("@/pages/admin/AdminLogin")), AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));

const ScrollTop = () => { const { pathname } = useLocation(); useEffect(() => { window.scrollTo(0, 0); }, [pathname]); return null; };

const SiteLayout = () => (
  <>
    <Navbar />
    <main id="main"><Outlet /></main>
    <Footer />
    <WhatsAppFloat />
    <StickyMobileCTA />
  </>
);

const Fallback = <div className="min-h-[50vh] flex items-center justify-center text-slate-500 font-mono text-sm">Loading…</div>;

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollTop />
        <Analytics />
        <Toaster theme="dark" position="top-right" richColors />
        <Suspense fallback={Fallback}>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/programs/compare" element={<Compare />} />
              <Route path="/programs/:slug" element={<CourseDetail />} />
              <Route path="/courses/:slug" element={<SeoLanding />} />
              <Route path="/learning-paths" element={<LearningPaths />} />
              <Route path="/market-lab" element={<MarketLab />} />
              <Route path="/mentors" element={<Mentors />} />
              <Route path="/nism" element={<Nism />} />
              <Route path="/events" element={<Events />} />
              <Route path="/student-stories" element={<StudentStories />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Article />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/community" element={<Community />} />
              <Route path="/book-counselling" element={<BookCounselling />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/privacy-policy" element={<Legal kind="privacy" />} />
              <Route path="/terms" element={<Legal kind="terms" />} />
              <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
              <Route path="/risk-disclosure" element={<Legal kind="risk" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}
